// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:24.880Z
// Property: Crown Chase Apts (ID: 6767906449165601)
// Collections: 24 amenities, 3 floorplans (live), 15 photos, 71 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165601",
  "property_external_id": "y4mgjjs",
  "property_zillow_url": "https://www.zillow.com/b/crown-chase-apartments-wichita-ks-5Xt4Cn/",
  "property_apartments_url": "https://www.apartments.com/crown-chase-apts-wichita-ks/y4mgjjs/",
  "property_google_business_url": "https://www.google.com/maps/place/Crown+Chase+Apartments/data=!4m2!3m1!1s0x0:0x3d23b93485948a80?sa=X&ved=2ahUKEwjHiYTt97ySAxV1STABHYmNFGwQ_BJ6BAhMEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "50085137982",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "crown-chase-apts",
  "property_name": "Crown Chase Apts",
  "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/crown-chase/",
  "property_domain": null,
  "property_address": "1010 North Ridge Road",
  "property_full_address": "1010 North Ridge Road, Wichita, KS, 67212",
  "property_address_1": "1010 N Ridge Rd",
  "property_address_2": null,
  "property_address_city": "Wichita",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "67212",
  "property_address_country": "US",
  "property_address_county": "Sedgwick County",
  "property_neighborhood_address": "West Wichita",
  "property_address_latitude": "37.7005",
  "property_address_longitude": "-97.426",
  "property_email": "crownchase@caseusa.com",
  "property_phone": "(316) 402-2837",
  "property_call_tracking_phone": "855-908-3814",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Crown Chase Apartments in Wichita, Kansas, vibrant living meets modern convenience. Choose from spacious one- and two-bedroom floor plans and enjoy amenities like a sparkling pool, fitness center, and tranquil walking trails. Experience community living with on-site management, gated access, and delightful lake views—your new home awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Crown Chase Apartments, the perfect blend of comfort and luxury nestled in the heart of Wichita, Kansas. Our charming community offers a variety of thoughtfully designed floor plans, featuring spacious one and two-bedroom apartments that cater to your lifestyle. Each residence is equipped with modern conveniences, including air conditioning, a fully-equipped kitchen with a microwave and dishwasher, and generous walk-in closets.\n\nAt Crown Chase, we elevate your living experience with our outstanding amenities. Dive into our sparkling pool to relax or break a sweat at our state-of-the-art fitness center. Enjoy socializing in our inviting clubhouse, or take advantage of our on-site business center for your professional needs. Experience the convenience of on-site laundry facilities and package service, all secured within a gated community.\n\nFor those who treasure outdoor living, numerous walking and biking trails await right outside your doorstep, along with serene lake access for leisurely weekends. Our pet-friendly environment includes a dedicated dog park and a spacious pet play area, ensuring your furry friends feel right at home. \n\nCrown Chase Apartments provide a lifestyle that balances leisure and convenience, featuring additional perks like high-speed internet access, a sundeck with grills, and a responsive maintenance team available on-site. \n\nYour new home awaits! Discover the vibrant lifestyle and community spirit at Crown Chase Apartments. Explore our availability or schedule a tour today to experience the perfect apartment in Wichita, Kansas!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-c635-7308-ba24-5dc7d2c2c24d.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment building entrance with mailboxes and landscaping.",
    "public_id": "019cfb3f-c635-7308-ba24-5dc7d2c2c24d",
    "storage_key": "property/6767906449165601/019cfb3f-c635-7308-ba24-5dc7d2c2c24d.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "384",
  "property_year_built": "1998",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.65625",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "325",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets allowed, each with a maximum weight of 80 pounds.",
  "property_pet_policy_description": "Residents are permitted a maximum of two pets (cats or dogs). There is no weight limit. Pet rent is $30 per pet per month, and there is a one-time, non‑refundable fee equal to half a month’s rent per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://crownchaseapartmentswichita.securecafe.com/onlineleasing/crown-chase-apts/floorplans.aspx",
  "property_resident_portal_url": "https://crownchaseapartmentswichita.securecafe.com/residentservices/crown-chase-apts/userlogin.aspx",
  "property_apply_now_url": "https://crownchaseapartmentswichita.securecafe.com/onlineleasing/crown-chase-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-a7dc-771c-b092-320e28280537.webp",
  "property_primary_logo_media": {
    "alt_text": "Crown Chase logo",
    "public_id": "019cfb3e-a7dc-771c-b092-320e28280537",
    "storage_key": "property/6767906449165601/019cfb3e-a7dc-771c-b092-320e28280537.webp",
    "width": 600,
    "height": 548
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-bb90-732c-8438-b44cdb5b94ed.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb3f-bb90-732c-8438-b44cdb5b94ed",
    "storage_key": "property/6767906449165601/019cfb3f-bb90-732c-8438-b44cdb5b94ed.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-ec9a-73d3-b4c1-fe44110a4386.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Crown Chase logo",
    "public_id": "019cfb3f-ec9a-73d3-b4c1-fe44110a4386",
    "storage_key": "property/6767906449165601/019cfb3f-ec9a-73d3-b4c1-fe44110a4386.webp",
    "width": 600,
    "height": 548
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-f4db-77fb-bde2-cf8b546ff8e0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Crown Chase logo",
    "public_id": "019cfb3f-f4db-77fb-bde2-cf8b546ff8e0",
    "storage_key": "property/6767906449165601/019cfb3f-f4db-77fb-bde2-cf8b546ff8e0.webp",
    "width": 600,
    "height": 548
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#5e6259",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#ffb548",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "738 - 978",
  "property_sqft_min": "738",
  "property_sqft_max": "978",
  "property_price_range": "954 - 1274",
  "property_price_min": "954",
  "property_price_max": "1274",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/crownchaseapartments/albums/468596391942667/",
  "property_instagram_url": "https://www.instagram.com/crownchaseapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ444AZIjguocRgIqUhTS5Iz0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/crown-chase-apartments-wichita-2",
  "property_tiktok_url": "https://www.tiktok.com/@crownchase",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Crown Chase Apts",
  "property_home_romance_title": "Embrace Your Dream Life at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Crown Chase Apts, where modern living meets comfort in the heart of Wichita, Kansas. With spacious one and two-bedroom floor plans, you’ll enjoy a wealth of amenities—from a sparkling pool and scenic waterfront access to a pet-friendly dog park. Live your best life at Crown Chase!",
  "property_home_floorplans_blurb": "At Crown Chase Apts in Wichita, Kansas, we offer stylish one and two-bedroom floor plans designed for comfort and convenience. Each layout reflects modern living, perfectly suited for your lifestyle. Browse our available apartment homes today and uncover the ideal space that feels just right for you!",
  "property_home_gallery_blurb": "Welcome to Crown Chase Apts in Wichita, Kansas, where modern living meets serene lakeside charm. Choose from spacious one or two-bedroom floor plans, each featuring high-end amenities like a refreshing pool, fitness center, and tranquil dog park. Picture yourself basking in comfort and style—your new home awaits!",
  "property_home_neighborhood_blurb": "At Crown Chase Apts in Wichita, Kansas, our vibrant community is surrounded by esteemed educational institutions, including Wichita State University and Butler Community College. Choose from spacious one or two-bedroom floor plans, and immerse yourself in a neighborhood rich with learning opportunities. See what's around our community and discover local favorites!",
  "property_home_reviews_blurb": "Experience the charm of Crown Chase Apartments in Wichita, Kansas, where residents rave about spacious layouts and stunning views. With prompt, friendly service and well-maintained grounds, you'll feel right at home. As one happy resident says, \"Nothing but good things to say about this property.\" Join our community today!",
  "property_neighborhood_blurb": "At Crown Chase Apartments in Wichita, Kansas, our community is surrounded by esteemed educational institutions like Newman University, Wichita State University, and Butler Community College. With a vibrant neighborhood filled with schools and learning centers, you’ll find the perfect balance of comfort and convenience. Dive into local favorites and uncover what awaits nearby!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Crown Chase Apts in Wichita, your comfort meets convenience. Enjoy our sparkling pool, state-of-the-art fitness center, and inviting clubhouse, all nestled alongside serene lake access. With spacious one and two-bedroom layouts and amenities like a dog park and walking trails, your perfect home awaits—tailored to elevate your lifestyle.",
  "property_applynow_blurb": "Welcome to Crown Chase Apartments in Wichita, Kansas, where luxury meets comfort. Choose from inviting one and two-bedroom floor plans, complete with modern amenities like a sparkling pool, fitness center, and serene waterfront access. Embrace a lifestyle of convenience—apply online today and find your perfect home!",
  "property_contactus_blurb": "At Crown Chase Apts in vibrant Wichita, Kansas, we offer thoughtfully designed one and two-bedroom floor plans to fit your lifestyle. Each space blends comfort with modern aesthetics. Have questions? Our friendly leasing team is ready to assist you—reach out today to start your journey to a new home!",
  "property_faqs_blurb": "At Crown Chase Apts in Wichita, Kansas, our diverse floor plans cater to every lifestyle, from cozy one-bedroom retreats to spacious two-bedroom homes. Curious about amenities, pet policies, or leasing? Visit our FAQs page to uncover answers and discover what makes our community truly special. Your perfect home awaits!",
  "property_floorplans_blurb": "At Crown Chase Apts in Wichita, Kansas, your ideal home awaits! Choose from our thoughtfully designed one-bedroom and spacious two-bedroom floor plans, tailored for your lifestyle. Each space reflects modern living with comfort and convenience. Browse our available apartment homes and uncover the perfect fit for your unique needs!",
  "property_gallery_blurb": "At Crown Chase Apartments in Wichita, Kansas, your perfect home awaits. Choose from spacious one or two-bedroom apartments featuring modern amenities like a stunning waterfront view, a refreshing pool, and a dog park. Picture yourself living here, enjoying the lifestyle you deserve with endless comfort and convenience!",
  "property_interactivemap_blurb": "Welcome to Crown Chase Apts in Wichita, Kansas, where modern comfort meets serene waterfront living. Choose from spacious one- or two-bedroom floor plans designed with your lifestyle in mind. Enjoy amenities like a shimmering pool, fitness center, and a dog park. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Crown Chase Apts in Wichita, Kansas, your furry friends are more than welcome! With spacious living and a pet-friendly policy for dogs and cats up to 80 pounds, your pets can enjoy life as much as you do. Embrace comfort and community where every member of the family can thrive.",
  "property_referafriend_blurb": "At Crown Chase Apts in vibrant Wichita, Kansas, our diverse floor plans—cozy one-bedroom and spacious two-bedroom options—ensure you find the perfect fit. Great friends make great neighbors, so share your love for our community and refer a friend today! Enjoy living where connections flourish.",
  "property_residentaccess_blurb": "Welcome to Crown Chase Apts in vibrant Wichita, Kansas! Whether you're seeking the cozy charm of a one-bedroom or the spacious comfort of a two-bedroom, we have the perfect floor plan for you. Log in to your resident portal for convenient rent payments and hassle-free maintenance scheduling today!",
  "property_reviews_blurb": "At Crown Chase Apartments in Wichita, residents rave about the stunning amenities and attentive management. With spacious layouts, pristine grounds, and a serene pond for fishing, one tenant notes, \"I would love it without the saltwater pool!\" Dive into a community where comfort meets convenience—your ideal home awaits!",
  "property_created_at": "1753982383037",
  "property_scheduletour_blurb": "At Crown Chase Apartments in Wichita, Kansas, choose from spacious one or two-bedroom floor plans tailored for your lifestyle. Experience the vibrant community atmosphere and amenities designed for comfort. Schedule a tour today and hear firsthand what our residents cherish about calling Crown Chase home!",
  "property_thankyou_blurb": "Thank you for reaching out to Crown Chase Apts in vibrant Wichita, Kansas! Your inquiry is important to us, and a team member will connect with you soon. With spacious one and two-bedroom floor plans, your perfect home awaits at Crown Chase. Get ready to elevate your living experience!",
  "property_virtualtours_blurb": "Experience the charm of Crown Chase Apts in Wichita, Kansas, with our thoughtfully designed one and two-bedroom floor plans. Each space offers modern comfort and style, inviting you to make it your own. Step into your new life—take a virtual tour of our vibrant community and available apartments today!",
  "property_copyright": "2025 All Rights Reserved. Crown Chase Apts",
  "property_seo_title_home": "Crown Chase Apts |  Apartments in Wichita, Kansas",
  "property_seo_description_home": "Welcome to Crown Chase Apts in Wichita, KS! Enjoy our stunning pool, spacious layouts, and pet-friendly amenities. Your new home awaits—make the move today!",
  "property_seo_title_floorplans": "Floor Plans | Wichita, Kansas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Crown Chase Apts in Wichita, KS. Choose from stylish one and two-bedroom floor plans that fit your lifestyle. Check them out today!",
  "property_seo_title_amenities": "Amenities | Wichita, Kansas Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at Crown Chase Apts in Wichita! Enjoy top-tier amenities, from a stunning pool to a pet-friendly park. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Wichita, Kansas",
  "property_seo_description_gallery": "Discover Crown Chase Apts in Wichita, KS—luxurious amenities and stunning waterfront views await. Imagine your new life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Crown Chase Apts Apartments",
  "property_seo_description_virtualtours": "Step inside Crown Chase Apts in Wichita, KS! Experience modern one and two-bedroom designs. Take a virtual tour to find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Crown Chase Apts Apartments",
  "property_seo_description_interactivemap": "Find your perfect fit at Crown Chase Apts in Wichita! Use our interactive map to explore spacious one- and two-bedroom layouts, amenities, and pricing.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Wichita, Kansas",
  "property_seo_description_neighborhood": "Discover local gems near Crown Chase Apts in Wichita, KS! Enjoy vibrant neighborhoods, parks, and dining just steps away from home!",
  "property_seo_title_contact": "Contact Us | Crown Chase Apts",
  "property_seo_description_contact": "Elevate your lifestyle at Crown Chase Apts in Wichita, KS. With one and two-bedroom options, our team is ready to assist you—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Wichita, Kansas",
  "property_seo_description_faqs": "Find answers to your questions at Crown Chase Apts in Wichita, KS! Explore amenities, living options, and embrace your new lifestyle.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Wichita, Kansas",
  "property_seo_description_reviews": "Discover vibrant living at Crown Chase Apts in Wichita! Check out resident reviews and find your perfect home today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Wichita, Kansas",
  "property_seo_description_applynow": "Find your perfect home at Crown Chase Apts in Wichita! Enjoy stunning amenities like a pool, fitness center, & waterfront access. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Crown Chase Apts",
  "property_seo_description_residentaccess": "Stay connected at Crown Chase Apts! Access your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Crown Chase Apts",
  "property_seo_description_referafriend": "Share the love! Refer a friend to Crown Chase Apts in Wichita and create lasting memories with great neighbors in a vibrant community. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Crown Chase Apts",
  "property_seo_description_scheduletour": "Experience luxury living at Crown Chase Apts in Wichita! Schedule your tour today and find your perfect home in our vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | Crown Chase Apts",
  "property_seo_description_privacy": "At Crown Chase Apts in Wichita, we prioritize your privacy. Learn how we protect your information and ensure a secure living experience. View our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Crown Chase Apts",
  "property_seo_description_accessibility": "At Crown Chase Apts in Wichita, we prioritize digital inclusion. Experience accessible living and vibrant community engagement at every turn. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Crown Chase Apts",
  "property_seo_description_sitemap": "Navigate through Crown Chase Apts in Wichita, KS! Uncover every detail and find your perfect home — check out our comprehensive sitemap now.",
  "property_seo_title_thankyou": "Thank You | Crown Chase Apts",
  "property_seo_description_thankyou": "Thank you for reaching out to Crown Chase Apts in Wichita! Our team will connect soon. Your future home awaits—stay tuned for exciting next steps!",
  "property_seo_title_pets": "Pet Policy | Apartments in Wichita, Kansas",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865173124",
  "amenities": [
    {
      "id": "ec_5a0bb5af005385cdbf725a64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396529",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb1e62e53768e0ff1345ae31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396532",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a08dca02cb0fc3b66178cc4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396533",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2737b78cd27be0fceaaf4d6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396534",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a0d25cca5dfee81d677e703",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396535",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fbcc48daf8487357931329d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396536",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b2e82cea3ba0b7251777fd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396538",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2f420bc9b3213f67034d330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "128042503",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd098b9d49ec9f64a2cddd78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396539",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51b0c3dc536c440aafc3de5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396540",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8317fe6629fbdb73273dfa38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "128017281",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0944b15ac33a752bfc9e6b79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127396541",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b5fb1a23aad8eb9eb56899b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398009",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6a1dd3bc9fc3e800b3c77b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398010",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d94e6c9c3b0cae97f83ac087",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398011",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c2dd77e81aad85b4e37a93b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398012",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_619abc6653de985db73f1f1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398013",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5085afae4c41515577b67500",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398014",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05665f5b3bfede3c8b9da9ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398015",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0844465ef24dad87fdfd0fde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398016",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6213645d5c40d80839c764cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398017",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f2ed4922005b0fdfc9432e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398018",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd485c687407edde17f37e6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398019",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_057c38d8ea93ec46d8e3c0ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "yardi",
      "external_id": "127398020",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_cfbe318e-0c43-4b73-bb18-345f1d7c559f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-8882-72aa-a371-77bdc9bccad8.webp",
      "image_media": {
        "alt_text": "Image of a multi-story apartment building with green grass and trees in the foreground.",
        "public_id": "019d2708-8882-72aa-a371-77bdc9bccad8",
        "storage_key": "property/6767906449165601/019d2708-8882-72aa-a371-77bdc9bccad8.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Explore the inviting exterior of our community, featuring beautifully landscaped grounds and spacious apartment buildings. Enjoy a serene living environment just steps from your door.",
      "link": "",
      "alt_text": "Image of a multi-story apartment building with green grass and trees in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2Fa96be728fd3f982d8333fe61bfeeae42.webp"
    },
    {
      "id": "custom_a1dcbb62-d892-4e67-81f3-0ab6b5ec043b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-8875-71ff-a6ff-415cd37b1707.webp",
      "image_media": {
        "alt_text": "Pathway through landscaped apartment complex",
        "public_id": "019d2708-8875-71ff-a6ff-415cd37b1707",
        "storage_key": "property/6767906449165601/019d2708-8875-71ff-a6ff-415cd37b1707.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Enjoy a serene community atmosphere with beautiful landscaping, connecting pathways, and charming apartment buildings. Ideal for relaxing walks and socializing with neighbors.",
      "link": "",
      "alt_text": "Pathway through landscaped apartment complex",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F4b46f4b914220d09a1f975bd153ce043.webp"
    },
    {
      "id": "custom_7319fe1a-b678-4b82-b859-67133ac51613",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-8899-76aa-9f60-ffee9cbc28b9.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and exercise machines",
        "public_id": "019d2708-8899-76aa-9f60-ffee9cbc28b9",
        "storage_key": "property/6767906449165601/019d2708-8899-76aa-9f60-ffee9cbc28b9.webp",
        "width": 1600,
        "height": 1282
      },
      "title": "Community",
      "description": "Step into our modern fitness center, equipped with state-of-the-art treadmills and exercise machines to help you stay active and healthy.",
      "link": "",
      "alt_text": "Fitness center with treadmills and exercise machines",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2Ff4fd1e37d0de0962882b799ef0b07202.webp"
    },
    {
      "id": "custom_71437220-1547-46af-abf9-eb0d2a1b5224",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-8868-75b8-ba15-3783791a928b.webp",
      "image_media": {
        "alt_text": "Common area featuring a fireplace, seating, and a TV.",
        "public_id": "019d2708-8868-75b8-ba15-3783791a928b",
        "storage_key": "property/6767906449165601/019d2708-8868-75b8-ba15-3783791a928b.webp",
        "width": 500,
        "height": 401
      },
      "title": "Community",
      "description": "Welcoming community lounge area designed for relaxation and social gatherings, featuring a fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Common area featuring a fireplace, seating, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2Fe086ac079228b48fcdb427cde7d1651a.webp"
    },
    {
      "id": "custom_df671f19-d5ab-42e6-b740-47c20c917ec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-9577-7256-829b-06a3a95d0c45.webp",
      "image_media": {
        "alt_text": "Lush green landscape near residential buildings by a lake",
        "public_id": "019d2708-9577-7256-829b-06a3a95d0c45",
        "storage_key": "property/6767906449165601/019d2708-9577-7256-829b-06a3a95d0c45.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Scenic view of the property grounds featuring a well-maintained lawn next to a tranquil lake, enhancing the community's outdoor living experience.",
      "link": "",
      "alt_text": "Lush green landscape near residential buildings by a lake",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F2c90c62a65736792de0268fde788597b.webp"
    },
    {
      "id": "custom_02fbb55a-1cc6-4a60-b9fd-75313ab0b38b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-9579-71fa-9347-d4e85ed1f41d.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment complex with grass and pathways",
        "public_id": "019d2708-9579-71fa-9347-d4e85ed1f41d",
        "storage_key": "property/6767906449165601/019d2708-9579-71fa-9347-d4e85ed1f41d.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Explore our beautifully landscaped community featuring modern apartment buildings surrounded by lush greenery and walking paths, ideal for relaxation and leisure.",
      "link": "",
      "alt_text": "Exterior view of an apartment complex with grass and pathways",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F6ac05e53d4c87c5e3f8baf9bf8dc20e9.webp"
    },
    {
      "id": "custom_30a07467-3b04-4b59-9d1b-91c330b131cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-96c8-75cf-84a9-b36ddddedbbf.webp",
      "image_media": {
        "alt_text": "Interior view of a gym with treadmills and exercise equipment",
        "public_id": "019d2708-96c8-75cf-84a9-b36ddddedbbf",
        "storage_key": "property/6767906449165601/019d2708-96c8-75cf-84a9-b36ddddedbbf.webp",
        "width": 500,
        "height": 401
      },
      "title": "Community",
      "description": "Experience a fully-equipped fitness center featuring state-of-the-art treadmills and exercise machines, perfect for maintaining an active lifestyle.",
      "link": "",
      "alt_text": "Interior view of a gym with treadmills and exercise equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F8062709c44bdd3fadc936bc25249dfeb.webp"
    },
    {
      "id": "custom_a7ed4993-4059-4338-bd1d-dbadde0aa630",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-96ca-76cf-8ec0-9899d47eeec3.webp",
      "image_media": {
        "alt_text": "Exterior view of community with pool and landscaping.",
        "public_id": "019d2708-96ca-76cf-8ec0-9899d47eeec3",
        "storage_key": "property/6767906449165601/019d2708-96ca-76cf-8ec0-9899d47eeec3.webp",
        "width": 500,
        "height": 334
      },
      "title": "Community",
      "description": "Enjoy a vibrant community atmosphere with well-maintained landscaping and a sparkling pool, perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Exterior view of community with pool and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F7d31a2f2aece2e45815cf0faf038bbc4.webp"
    },
    {
      "id": "custom_aa4e6416-6930-4212-a447-1b0f93d87034",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-a0ba-76de-9ef8-e2d141b87cf5.webp",
      "image_media": {
        "alt_text": "Exterior view of the property office with landscaped yard",
        "public_id": "019d2708-a0ba-76de-9ef8-e2d141b87cf5",
        "storage_key": "property/6767906449165601/019d2708-a0ba-76de-9ef8-e2d141b87cf5.webp",
        "width": 500,
        "height": 333
      },
      "title": "Community",
      "description": "Welcoming community office featuring elegant architecture and well-maintained landscaping, ideal for resident services.",
      "link": "",
      "alt_text": "Exterior view of the property office with landscaped yard",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2Fea88f54414eed0d5501c9acdd888719b.webp"
    },
    {
      "id": "custom_4e8234b9-a021-4a63-96d5-62b68ecac475",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-a203-735f-bee6-3c8369aeb83d.webp",
      "image_media": {
        "alt_text": "Cozy living room featuring a light gray sofa and modern decor",
        "public_id": "019d2708-a203-735f-bee6-3c8369aeb83d",
        "storage_key": "property/6767906449165601/019d2708-a203-735f-bee6-3c8369aeb83d.webp",
        "width": 1600,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Explore this inviting apartment living space, showcasing contemporary furnishings, plush carpeting, and stylish accents. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Cozy living room featuring a light gray sofa and modern decor",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F5bb5500b4b0492fa77fa1b2046b0ebd5.webp"
    },
    {
      "id": "custom_695a1a19-1e48-463d-aceb-2f85a6ad1d27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-a4c5-71b1-a94e-e24cf650f94d.webp",
      "image_media": {
        "alt_text": "Cozy living room with a sofa, fireplace, and artwork",
        "public_id": "019d2708-a4c5-71b1-a94e-e24cf650f94d",
        "storage_key": "property/6767906449165601/019d2708-a4c5-71b1-a94e-e24cf650f94d.webp",
        "width": 500,
        "height": 401
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully designed apartment featuring a spacious living area, complete with stylish decor and a warm fireplace.",
      "link": "",
      "alt_text": "Cozy living room with a sofa, fireplace, and artwork",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2Ff0a744b5b82f013cfdbb745367ce917b.webp"
    },
    {
      "id": "custom_8b4f525e-991e-4ba8-b421-fae9f28dd0d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-a502-7248-96b0-3b3be922b469.webp",
      "image_media": {
        "alt_text": "Well-decorated bedroom with a large bed and natural light",
        "public_id": "019d2708-a502-7248-96b0-3b3be922b469",
        "storage_key": "property/6767906449165601/019d2708-a502-7248-96b0-3b3be922b469.webp",
        "width": 500,
        "height": 401
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a stylish bed with plush headboard, accent pillows, and a cozy aesthetic.",
      "link": "",
      "alt_text": "Well-decorated bedroom with a large bed and natural light",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F7b5adf181ad533e58bc1001ac3b8398d.webp"
    },
    {
      "id": "custom_466a079a-6eb4-4252-adea-471184917a0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-acec-771f-9371-971532389756.webp",
      "image_media": {
        "alt_text": "Aerial view of a cityscape featuring buildings, streets, and trees.",
        "public_id": "019d2708-acec-771f-9371-971532389756",
        "storage_key": "property/6767906449165601/019d2708-acec-771f-9371-971532389756.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Lifestyle",
      "description": "Explore the vibrant community with this aerial view highlighting the dynamic urban environment and surrounding greenery.",
      "link": "",
      "alt_text": "Aerial view of a cityscape featuring buildings, streets, and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F0856c5191750775af98cee7e59a91213.jpg"
    },
    {
      "id": "custom_bb40c9d1-48dd-4bce-a949-bbaa6a872b9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-afcd-75cb-beb4-5ae44ad5b711.webp",
      "image_media": {
        "alt_text": "A statue standing on a rocky base near a body of water during twilight.",
        "public_id": "019d2708-afcd-75cb-beb4-5ae44ad5b711",
        "storage_key": "property/6767906449165601/019d2708-afcd-75cb-beb4-5ae44ad5b711.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "A beautiful view of the community's iconic statue by the water, accented by a picturesque skyline in the evening light.",
      "link": "",
      "alt_text": "A statue standing on a rocky base near a body of water during twilight.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F0dc9ef398f643c3aa216c2b3b5b59d89.jpg"
    },
    {
      "id": "custom_23d7fff4-efef-4cfa-b887-ccb848c0e5be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d2708-b24f-7679-b877-806502ae1b02.webp",
      "image_media": {
        "alt_text": "Silhouette of a city skyline against an orange sunset",
        "public_id": "019d2708-b24f-7679-b877-806502ae1b02",
        "storage_key": "property/6767906449165601/019d2708-b24f-7679-b877-806502ae1b02.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Lifestyle",
      "description": "Stunning view of the city skyline at sunset, ideal for showcasing the vibrant community you can call home.",
      "link": "",
      "alt_text": "Silhouette of a city skyline against an orange sunset",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165601%2F051e9d5780408ebf8712ec271ea09fd7.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_bb3be70c-53e8-4443-be5c-98d0f4c3a5f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "6707 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, prime rib, and appetizers, and the food is consistently good. They highlight the fun, lively atmosphere and the generous portions of rolls and cinnamon butter. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3b18-722f-a2ea-001f829cabfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3b18-722f-a2ea-001f829cabfc",
        "storage_key": "property/6767906449165601/019cfb3f-3b18-722f-a2ea-001f829cabfc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/kansas/wichita-west-kellogg?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10790040154516989602&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "37.6720244",
      "poi_longitude": "-97.4200102",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-943-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_Fxv7nguocRoqYvOlrsvZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_37006df9-bff3-4b74-bd72-1a7164272a54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "HomeGrown",
      "poi_type": "Restaurants",
      "poi_address": "645 E Douglas Ave Ste 102, Wichita, KS 67202, USA",
      "poi_short_description": "Open-space eatery with a 'choose kind' motto, serving breakfast items and lunch dishes such as pancakes, waffles and French toast.",
      "poi_long_description": "People say this breakfast restaurant serves delicious biscuits and gravy, French toast, and gluten-free pancakes. They highlight the fresh, locally sourced ingredients and the affordable prices. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f449-70ec-a8e9-8fdf5ce11f09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f449-70ec-a8e9-8fdf5ce11f09",
        "storage_key": "property/6767906449165601/019cfb3e-f449-70ec-a8e9-8fdf5ce11f09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homegrownkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10686225532294437036&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "homegrown",
      "poi_latitude": "37.6856462",
      "poi_longitude": "-97.3309449",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-247-9509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaY-BPffjuocRrJge6oAZTZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e531f368-1634-487a-ab00-a55128e3c14b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Doo-Dah Diner",
      "poi_type": "Restaurants",
      "poi_address": "206 E Kellogg St, Wichita, KS 67202, USA",
      "poi_short_description": "Homey diner serving from-scratch American breakfast & lunch classics, from pancakes to burgers.",
      "poi_long_description": "People say this diner serves delicious banana bread French toast, biscuits and gravy, and monkey bread. They highlight the generous portions, homemade food, and fun, cozy vibe. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f498-72e2-901e-c3b4733ed638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f498-72e2-901e-c3b4733ed638",
        "storage_key": "property/6767906449165601/019cfb3e-f498-72e2-901e-c3b4733ed638.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://doodahdiner.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12690445211555488726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "doo-dah-diner",
      "poi_latitude": "37.6796006",
      "poi_longitude": "-97.3364484",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13z0ke7juocR1mNS3K6EHbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_d18ce9ce-b8ac-40e4-88ba-c24892c21e17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "7320 W Taft St, Wichita, KS 67209, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, waffle fries, and fresh salads. They highlight the friendly staff and quick service, especially for online orders. They also like the clean facility and positive, Christian vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3ac9-7492-8bed-c524b5588e08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3ac9-7492-8bed-c524b5588e08",
        "storage_key": "property/6767906449165601/019cfb3f-3ac9-7492-8bed-c524b5588e08.webp",
        "width": 782,
        "height": 430
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ks/maple-ridge?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3878166640798646112&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "37.6772557",
      "poi_longitude": "-97.4268918",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-729-2697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2yIMLvhuocRYL-SLAME0jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d8feb11d-961c-4076-81ba-9ec29581c87d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "120 S Washington Ave, Wichita, KS 67202, USA",
      "poi_short_description": "Chain offering Mediterranean staples (shawarma, hummus and falafel) plus wines, beers and cocktails.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious chicken shawarma, hummus, and falafel. They highlight the generous portions, fair prices, and fresh, flavorful food. They also like the friendly and efficient service, and the warm, inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3adc-7169-8760-11ab83bafcc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3adc-7169-8760-11ab83bafcc0",
        "storage_key": "property/6767906449165601/019cfb3f-3adc-7169-8760-11ab83bafcc0.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.meddys.com/contact-us/locations/meddys-downtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18251280396411841812&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "37.6854344",
      "poi_longitude": "-97.3261458",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-201-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZpbE6XjuocRFK0tNNKSSf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_1430b27b-1766-453b-ad81-fb53ce591a00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8444 W McCormick Ave, Wichita, KS 67209, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products for home and garden projects. They also highlight the helpful and professional staff, and the well-stocked and clean store.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f4c8-75a5-b042-65c0f66e38ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f4c8-75a5-b042-65c0f66e38ce",
        "storage_key": "property/6767906449165601/019cfb3e-f4c8-75a5-b042-65c0f66e38ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/West-Wichita/KS/Wichita/67209/2205?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13722908378629795426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "37.6738686",
      "poi_longitude": "-97.4402648",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-773-1988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ0S0uR3euocRYu51mXaQcb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_78152391-ddd9-4df7-9db4-567456eedc28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3660 N Maize Rd, Wichita, KS 67205, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers a wide selection of building supplies, hardware, patio equipment, appliances, paint, lighting, and lawn and garden decor. They also highlight the good prices, easy returns, and helpful staff.\n\nOther reviews mention the store can be difficult to navigate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f5b7-7231-84e2-521556d78417.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f5b7-7231-84e2-521556d78417",
        "storage_key": "property/6767906449165601/019cfb3e-f5b7-7231-84e2-521556d78417.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3276&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4195684929713849559&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "37.7497617",
      "poi_longitude": "-97.4597743",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-729-5851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp792U3Igu4cR18QNwTYROjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_3360b598-db7b-4d50-a746-f578802367bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "333 S Ridge Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a great collection of plants. They also highlight the staff is helpful and easy to park.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f43c-7507-8a43-55ec4367d55a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f43c-7507-8a43-55ec4367d55a",
        "storage_key": "property/6767906449165601/019cfb3e-f43c-7507-8a43-55ec4367d55a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/KS-Wichita/0614?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-614-_-na-_-0-_-0&y_source=1_MTE4MzEwNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050313256936817436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "37.678859",
      "poi_longitude": "-97.428188",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-773-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPUZP16LguocRHEPaHJLhnuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_b03712c3-e8b4-4d60-b4bd-19721bc4d4c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Thai Binh Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1530 W 21st St, Wichita, KS 67203, USA",
      "poi_short_description": "Sprawling Asian-style grocery stocking produce and cooking utensils, plus hot foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f5b4-748e-8340-6ecda2c82362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f5b4-748e-8340-6ecda2c82362",
        "storage_key": "property/6767906449165601/019cfb3e-f5b4-748e-8340-6ecda2c82362.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/Thai-Binh-Supermarket/165438916815347",
      "poi_directions_map_url": "https://maps.google.com/?cid=12975717193484190098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thai-binh-supermarket",
      "poi_latitude": "37.723579",
      "poi_longitude": "-97.355179",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-838-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-097f-724f-ae20-5be4ae3dc458.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-097f-724f-ae20-5be4ae3dc458",
        "storage_key": "property/6767906449165601/019cfb3f-097f-724f-ae20-5be4ae3dc458.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMceJz4vhuocRksGNBwoCE7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_c83620ed-f04d-4080-b65c-df4647f1c4b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Mi Super Mercado Baratísimo - Seneca - Wichita",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 S Seneca St, Wichita, KS 67217, USA",
      "poi_short_description": "Traditional Mexican grocery store featuring fresh produce, desserts, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f5a8-71eb-be36-61deb11aafde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f5a8-71eb-be36-61deb11aafde",
        "storage_key": "property/6767906449165601/019cfb3e-f5a8-71eb-be36-61deb11aafde.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://www.elriobravokck.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6659820061076927&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mi-super-mercado-baratsimo---seneca---wichita",
      "poi_latitude": "37.6493786",
      "poi_longitude": "-97.3545534",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-269-9119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-097f-724f-ae20-5be4ae3dc458.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-097f-724f-ae20-5be4ae3dc458",
        "storage_key": "property/6767906449165601/019cfb3f-097f-724f-ae20-5be4ae3dc458.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaCidSHnuocRvy0CMRKpFwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_419a3c97-79a0-4596-a9f2-31b199e6349a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Wichita Public Library - Advanced Learning Library",
      "poi_type": "Education",
      "poi_address": "711 West 2nd St N, Wichita, KS 67203, USA",
      "poi_short_description": "Relaxed public library featuring books and media for kids and adults, plus play spaces, a studio and computers.",
      "poi_long_description": "People say this public library offers a wide selection of books, access to technology, and free classes and live events. They highlight the clean and quiet atmosphere, and the spacious layout with plenty of seating. They also like the helpful staff and the availability of meeting rooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f850-7138-a36f-921a5b22de36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f850-7138-a36f-921a5b22de36",
        "storage_key": "property/6767906449165601/019cfb3e-f850-7138-a36f-921a5b22de36.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wichitalibrary.org/Locations/Pages/advanced-learning-library.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1540515458718365609&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-public-library---advanced-learning-library",
      "poi_latitude": "37.68664890000001",
      "poi_longitude": "-97.3479505",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-261-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfx2pGt7juocRqffnz6UCYRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_482f5eb2-f6f5-412d-8613-40ff985025a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Friends University",
      "poi_type": "Education",
      "poi_address": "2100 W Univ Ave, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f8f2-75be-9b54-5f03f7d0fc86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f8f2-75be-9b54-5f03f7d0fc86",
        "storage_key": "property/6767906449165601/019cfb3e-f8f2-75be-9b54-5f03f7d0fc86.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://www.friends.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570531106663261673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friends-university",
      "poi_latitude": "37.6777089",
      "poi_longitude": "-97.3666702",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-295-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-zLPUThuocR6WXVmIujFdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e2e62b17-6f25-4c68-86ba-cabae9aa96d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Newman University",
      "poi_type": "Education",
      "poi_address": "3100 McCormick St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f909-72da-8b1a-5979b702988f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f909-72da-8b1a-5979b702988f",
        "storage_key": "property/6767906449165601/019cfb3e-f909-72da-8b1a-5979b702988f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.newmanu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8197001651856080544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newman-university",
      "poi_latitude": "37.673508",
      "poi_longitude": "-97.377744",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-942-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjRoRMzHhuocRoP4ropKZwXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3014059a-1b67-43f4-aea9-d9669ec2f124",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Wichita Public Library - Westlink Branch",
      "poi_type": "Education",
      "poi_address": "8515 Bekemeyer St, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this public library offers a wide selection of books, movies, TV series, and audiobooks. They highlight the renovated space is beautiful, clean, and comfortable, with plenty of seating and outlets. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f8fd-73fb-a19b-a66b131c50b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f8fd-73fb-a19b-a66b131c50b8",
        "storage_key": "property/6767906449165601/019cfb3e-f8fd-73fb-a19b-a66b131c50b8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.wichitalibrary.org/locations/pages/westlink.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6971528439597698411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-public-library---westlink-branch",
      "poi_latitude": "37.696964",
      "poi_longitude": "-97.4415485",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-337-9456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmzQVxiveuocRaw3B1y3Yv2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7f8cc093-e420-44aa-b3e3-6ea14cca2b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Sedgwick County Zoo",
      "poi_type": "Entertainment",
      "poi_address": "5555 W Zoo Blvd, Wichita, KS 67212, USA",
      "poi_short_description": "Animals organized by continent, plus educational programs for various age groups.",
      "poi_long_description": "Visitors say this zoo offers a variety of animal experiences, including giraffe feeding, stingray cove, a train ride, and a boat ride, and they praise the well-maintained habitats and friendly staff. They also highlight the family-friendly atmosphere, affordable season passes, and numerous special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3cbb-75db-bf36-f3fd960bba3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3cbb-75db-bf36-f3fd960bba3b",
        "storage_key": "property/6767906449165601/019cfb3f-3cbb-75db-bf36-f3fd960bba3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://scz.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11432857233417595508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-zoo",
      "poi_latitude": "37.717034",
      "poi_longitude": "-97.408561",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-660-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVutukTguocRdGqcdRSrqZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_41cab54a-d522-41c2-8db5-82be863cb603",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Exploration Place",
      "poi_type": "Entertainment",
      "poi_address": "300 N McLean Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Exhibits, films, live shows, & hands-on science & discovery programs for kids and adults.",
      "poi_long_description": "People say this science museum offers interactive exhibits, a shark exhibit, and a dome theater. They highlight the educational and entertaining experience, and the fun, hands-on activities for kids and adults. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-f9db-707c-9420-8950bf8050cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-f9db-707c-9420-8950bf8050cf",
        "storage_key": "property/6767906449165601/019cfb3e-f9db-707c-9420-8950bf8050cf.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "http://www.exploration.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14209503253032261092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "exploration-place",
      "poi_latitude": "37.6894665",
      "poi_longitude": "-97.3479609",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-660-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-097e-77d8-8dae-8645d20d3cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-097e-77d8-8dae-8645d20d3cdb",
        "storage_key": "property/6767906449165601/019cfb3f-097e-77d8-8dae-8645d20d3cdb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7tm5d7juocR5NW-Z-xLMsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_76ea4be7-d435-4d87-aaf3-90c81116deb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "INTRUST Bank Arena",
      "poi_type": "Entertainment",
      "poi_address": "500 E Waterman St, Wichita, KS 67202, USA",
      "poi_short_description": "State-of-the-art entertainment complex hosting sports, concerts, ice shows & conventions.",
      "poi_long_description": "People say this arena offers a variety of events, including hockey games and concerts. They also highlight the clean and well-laid-out venue, comfortable seating, and friendly staff.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-fa33-76fd-b1f9-def5c28baba3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-fa33-76fd-b1f9-def5c28baba3",
        "storage_key": "property/6767906449165601/019cfb3e-fa33-76fd-b1f9-def5c28baba3.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.intrustbankarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2995336029531607261&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intrust-bank-arena",
      "poi_latitude": "37.6832771",
      "poi_longitude": "-97.3320617",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-755-7328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ59VNcOvjuocR3RAptz-SkSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_9c358a51-7cb3-4350-a539-9d1e3eeb0b43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Wichita Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1400 Museum Blvd, Wichita, KS 67203, USA",
      "poi_short_description": "Contemporary & historical works from a 7,000-piece permanent collection, & a hands-on area for kids.",
      "poi_long_description": "People say this art museum offers a diverse collection of paintings, photography, and sculptures, including works by local artists and children. They highlight the free admission, the beautiful and colorful entrance, and the rotating exhibits and themes. They also like the family-friendly atmosphere and the fun activities for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-fb14-7060-9fac-78f21b7c0928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-fb14-7060-9fac-78f21b7c0928",
        "storage_key": "property/6767906449165601/019cfb3e-fb14-7060-9fac-78f21b7c0928.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://wam.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14953396795402545430&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-art-museum",
      "poi_latitude": "37.6949197",
      "poi_longitude": "-97.3559687",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-097e-77d8-8dae-8645d20d3cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-097e-77d8-8dae-8645d20d3cdb",
        "storage_key": "property/6767906449165601/019cfb3f-097e-77d8-8dae-8645d20d3cdb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0d-QWPhuocRFulurygjhc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_92df437e-b63e-4853-ab69-2d143db52e07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "8545 W Irving St, Wichita, KS 67209, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, a zip line, and a ropes course. They also highlight the clean facility and the friendly, helpful staff.\n\nOther reviews mention the height requirements can be unclear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-fa84-73dd-884d-f58a1a8a18e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-fa84-73dd-884d-f58a1a8a18e7",
        "storage_key": "property/6767906449165601/019cfb3e-fa84-73dd-884d-f58a1a8a18e7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/kansas-wichita/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7075506925871037131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "37.6701433",
      "poi_longitude": "-97.4414467",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 316-281-7173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJITbj0RzeuocRy_pbug9AMWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_8c0a662e-e74d-4a39-814c-315de3dbdfbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "WEST YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "6940 Newell St, Wichita, KS 67212, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes, including yoga, and has a kid zone. They also highlight the friendly staff and welcoming, homely vibe.\n\nOther reviews mention billing issues can be difficult to resolve.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3e1a-70f5-b5a8-9c4bb9d2eb5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3e1a-70f5-b5a8-9c4bb9d2eb5e",
        "storage_key": "property/6767906449165601/019cfb3f-3e1a-70f5-b5a8-9c4bb9d2eb5e.webp",
        "width": 504,
        "height": 378
      },
      "poi_business_url": "https://www.ymcawichita.org/locations/west-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=4228409214553971772&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6928199",
      "poi_longitude": "-97.4231272",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-942-2271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-onBo7guocRPFx6DsdTrjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f8640e81-5250-4101-bfd8-4e17466e3140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Richard A. DeVore SOUTH YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3405 S Meridian Ave Bldg. 1, Wichita, KS 67217, USA",
      "poi_short_description": "Fitness center offering clean facilities, exercise machines, hot tubs, and pools, plus classes.",
      "poi_long_description": "People say this gym offers a variety of equipment and classes. They also highlight the friendly staff and the convenient location.\n\nSome reviews mention the management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3ec9-71e6-9421-2a80b5e699e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3ec9-71e6-9421-2a80b5e699e9",
        "storage_key": "property/6767906449165601/019cfb3f-3ec9-71e6-9421-2a80b5e699e9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcawichita.org/locations/richard-devore-south-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6072621654783976938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "richard-a-devore-south-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6309425",
      "poi_longitude": "-97.3764392",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-942-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fD39JLmuocR6mW-jDhJRlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f09394b4-e9d7-41e5-8e0b-3ffc7e6f210d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Ken Shannon NORTHWEST Branch - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "13838 W 21st St N, Wichita, KS 67235, USA",
      "poi_short_description": "Familiar fitness club offering workout machines, classes (including swimming, yoga and Pilates), a pool and friendly staff, plus a sauna and steam room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-fc37-7134-9431-d32473f346ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-fc37-7134-9431-d32473f346ab",
        "storage_key": "property/6767906449165601/019cfb3e-fc37-7134-9431-d32473f346ab.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://ymcawichita.org/locations/ken-shannon-northwest-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593200057211516548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ken-shannon-northwest-branch---greater-wichita-ymca",
      "poi_latitude": "37.7232046",
      "poi_longitude": "-97.5035287",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-260-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5XYsWvfuocRhHYtD4XAf1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_565b64dd-5ba6-4680-bee0-cfceb1b4e218",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Robert D. Love Downtown YMCA - Greater Wichita YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "402 N Market St, Wichita, KS 67202, USA",
      "poi_short_description": "Nonprofit community center with an indoor track, pools, and courts for racquetball and basketball.",
      "poi_long_description": "People say this gym offers a variety of equipment, a pool, and a track. They also highlight the spacious layout, the separate saunas, and the friendly staff.\n\nOther reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3ecd-71ad-92f0-0044cfc428c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3ecd-71ad-92f0-0044cfc428c9",
        "storage_key": "property/6767906449165601/019cfb3f-3ecd-71ad-92f0-0044cfc428c9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcawichita.org/locations/robert-d-love-downtown-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=2962762509539940888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "robert-d-love-downtown-ymca---greater-wichita-ymca",
      "poi_latitude": "37.6924977",
      "poi_longitude": "-97.33655720000002",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 316-264-9374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfK39MPjuocRGBr5Fs7YHSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_92d6df8b-76e6-4a90-af31-62506dfe57b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Prime Time Barber Shop North Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "727 W 13th St N, Wichita, KS 67203, USA",
      "poi_short_description": "Barbershop featuring a friendly staff of skilled pros, plus kids' cuts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-fd3f-75ed-ad55-fda32f49b513.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-fd3f-75ed-ad55-fda32f49b513",
        "storage_key": "property/6767906449165601/019cfb3e-fd3f-75ed-ad55-fda32f49b513.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://getsquire.com/booking/book/prime-time-barbershop-north-wichita",
      "poi_directions_map_url": "https://maps.google.com/?cid=13837457956166592306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "prime-time-barber-shop-north-wichita",
      "poi_latitude": "37.7076339",
      "poi_longitude": "-97.3476791",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-219-3132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcaWNiviuocRMme2d7KGCMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_d67b28e5-f6b1-4b39-8120-fe12cb030e2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Veterinary Emergency & Specialty Hospital of Wichita",
      "poi_type": "Health and Wellness",
      "poi_address": "5618 W 21st St N, Wichita, KS 67205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3f9a-7480-a699-cea8ffafdc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3f9a-7480-a699-cea8ffafdc39",
        "storage_key": "property/6767906449165601/019cfb3f-3f9a-7480-a699-cea8ffafdc39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vetwichita.com/?y_source=1_MTUyMjkzNTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9151561644725192073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterinary-emergency--specialty-hospital-of-wichita",
      "poi_latitude": "37.7241153",
      "poi_longitude": "-97.4087979",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-262-5321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_YLl43juocRiUXvLdTgAH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e436ec3d-e6c7-4020-ad56-9f28beaed03a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - West Central",
      "poi_type": "Health and Wellness",
      "poi_address": "854 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "Gym and tennis club featuring weight machines, group classes, personal trainers, a pool, saunas and clean locker rooms.",
      "poi_long_description": "People say this gym offers personal training packages and nutrient products. They also highlight the 24-hour access.\n\nOther reviews mention the equipment can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-fd9a-7256-a50b-042e1941be01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3e-fd9a-7256-a50b-042e1941be01",
        "storage_key": "property/6767906449165601/019cfb3e-fd9a-7256-a50b-042e1941be01.webp",
        "width": 867,
        "height": 488
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/west-central.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3017945090160134620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---west-central",
      "poi_latitude": "37.6974426",
      "poi_longitude": "-97.4363575",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-721-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQpmYNjfuocR3Amh2hHl4Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_142fce7e-85ad-4804-868e-780cd4693f24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2021 N Amidon Ave, Wichita, KS 67203, USA",
      "poi_short_description": "Welcoming facility featuring strength-training equipment, cardio machines and tanning beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3fc0-72f4-b00e-8a9f421f52b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3fc0-72f4-b00e-8a9f421f52b4",
        "storage_key": "property/6767906449165601/019cfb3f-3fc0-72f4-b00e-8a9f421f52b4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/wichita-new-leaf-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6068367135117192520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "37.72080589999999",
      "poi_longitude": "-97.3649016",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-440-4808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1Ivu5HhuocRSK1Q_8ErN1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ba8b3b10-b66e-4788-8590-9248d479c690",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Limitless Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "8635 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Barbershop offering a variety of haircuts, including fades, in a friendly setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-405d-707a-b371-83b82d1505c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-405d-707a-b371-83b82d1505c1",
        "storage_key": "property/6767906449165601/019cfb3f-405d-707a-b371-83b82d1505c1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.limitlessbarbershop.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406037866442402230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "limitless-barbershop",
      "poi_latitude": "37.6927246",
      "poi_longitude": "-97.4428108",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-469-8087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwzn3G_fuocRtilwGbH2YyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_3380f38b-d8ad-443b-b09c-2c041e6def3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Francis",
      "poi_type": "Health and Wellness",
      "poi_address": "929 St Francis, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-3ffc-724b-b9e4-a47a85807fb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-3ffc-724b-b9e4-a47a85807fb2",
        "storage_key": "property/6767906449165601/019cfb3f-3ffc-724b-b9e4-a47a85807fb2.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-francis?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16408748786587986507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-francis",
      "poi_latitude": "37.6994424",
      "poi_longitude": "-97.3324685",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 316-268-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-095f-73fa-8ea7-0e294b42d096.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-095f-73fa-8ea7-0e294b42d096",
        "storage_key": "property/6767906449165601/019cfb3f-095f-73fa-8ea7-0e294b42d096.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQufU8jjuocRS-oyiRWWt-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a1ab65e0-a9ea-4408-a641-d000f80af59d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Ascension Via Christi St. Teresa",
      "poi_type": "Health and Wellness",
      "poi_address": "14800 St Teresa St, Wichita, KS 67235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-4076-7651-a859-016ca009f368.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-4076-7651-a859-016ca009f368",
        "storage_key": "property/6767906449165601/019cfb3f-4076-7651-a859-016ca009f368.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/kansas/kswic/wichita-ascension-via-christi-st-teresa?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15586166186925347435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-via-christi-st-teresa",
      "poi_latitude": "37.7257513",
      "poi_longitude": "-97.5132964",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-796-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-095f-73fa-8ea7-0e294b42d096.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-095f-73fa-8ea7-0e294b42d096",
        "storage_key": "property/6767906449165601/019cfb3f-095f-73fa-8ea7-0e294b42d096.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVzCgkXfuocRa9LjZZEvTdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8b4ad691-da5a-466c-9b39-d0d9568a80a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Botanica, The Wichita Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 Amidon St, Wichita, KS 67203, USA",
      "poi_short_description": "Imaginative, verdant botanical garden with children's areas, a butterfly house, events & more.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, a butterfly house, and a children's play area. They highlight the beautiful grounds, the fun and engaging activities for families, and the peaceful and tranquil atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-4156-73f8-a9ef-e0d9b184b61c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-4156-73f8-a9ef-e0d9b184b61c",
        "storage_key": "property/6767906449165601/019cfb3f-4156-73f8-a9ef-e0d9b184b61c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.botanica.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14898597451770473856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "botanica-the-wichita-gardens",
      "poi_latitude": "37.6964308",
      "poi_longitude": "-97.361781",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-264-0448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeda7xm_huocRgK1RPHJzws4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_134ace0e-8dc0-47ba-80eb-0e4cf37cf859",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Sedgwick County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6501 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Center for outdoor sports, recreation & fitness, with fishing on 4 lakes, plus shelter rentals.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, walking and biking trails, fishing, and picnic areas. They highlight the spaciousness, beautiful scenery, and family-friendly atmosphere. They also like the well-maintained facilities and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-009e-765b-885c-35b5d14a2414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-009e-765b-885c-35b5d14a2414",
        "storage_key": "property/6767906449165601/019cfb3f-009e-765b-885c-35b5d14a2414.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sedgwickcounty.org/parks/sedgwick-county-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1140188679586598057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sedgwick-county-park",
      "poi_latitude": "37.7093827",
      "poi_longitude": "-97.4184872",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-660-1780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-f36df31127ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-f36df31127ec",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-f36df31127ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6auLGjguocRqUyuJ5DD0g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0ef967cf-bcc9-49ae-88c6-b7631e7a3705",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Pawnee Prairie Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2625 S Tyler Rd, Wichita, KS 67209, USA",
      "poi_short_description": "Spacious outdoor park with trails for walking, biking & horseback-riding, plus picnic areas.",
      "poi_long_description": "People say this park offers beautiful walking trails, a bike path, and opportunities to see wildlife. They highlight the peaceful and natural escape from the city, and the well-maintained paths suitable for various skill levels. They also like the diverse trails, including a smooth path for beginners and more moderate dirt paths. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-41ef-75ee-be30-57fe38f8bb6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-41ef-75ee-be30-57fe38f8bb6f",
        "storage_key": "property/6767906449165601/019cfb3f-41ef-75ee-be30-57fe38f8bb6f.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Pawnee-Prairie-Park-200",
      "poi_directions_map_url": "https://maps.google.com/?cid=7082970089037678459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pawnee-prairie-park",
      "poi_latitude": "37.65121",
      "poi_longitude": "-97.4566587",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-f36df31127ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-f36df31127ec",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-f36df31127ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99dH-O_duocRe8fOz8TDS2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_049cdaf5-09dc-4728-9ad1-f578c0da1620",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Central Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "720 Nims, Wichita, KS 67203, USA",
      "poi_short_description": "Large park featuring a miniature zoo, playgrounds, a splash pad, walking paths & picnic areas.",
      "poi_long_description": "Visitors say this city park is a great place for picnics, with plenty of trees and space to play Frisbee. They also highlight the playground and barbecue areas, making it a popular spot for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0076-762f-a829-d7907243c654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0076-762f-a829-d7907243c654",
        "storage_key": "property/6767906449165601/019cfb3f-0076-762f-a829-d7907243c654.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Central-Riverside-Park-43",
      "poi_directions_map_url": "https://maps.google.com/?cid=10285259190793395628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-riverside-park",
      "poi_latitude": "37.6970794",
      "poi_longitude": "-97.3466547",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-268-4361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-f36df31127ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-f36df31127ec",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-f36df31127ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJicxOUdfjuocRrN0Pir2UvI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c7fef7e9-70c6-4972-b2b1-709cdd0b75bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Auburn Hills Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "443 S 135th St W, Wichita, KS 67235, USA",
      "poi_short_description": "Public course featuring 18 holes with tight corridors, rolling hills and wetlands areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-01a1-75dd-94b9-34df155a9a44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-01a1-75dd-94b9-34df155a9a44",
        "storage_key": "property/6767906449165601/019cfb3f-01a1-75dd-94b9-34df155a9a44.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/Facilities/Facility/Details/Auburn-Hills-Golf-Course-148",
      "poi_directions_map_url": "https://maps.google.com/?cid=15217307189274254099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "auburn-hills-golf-course",
      "poi_latitude": "37.6740167",
      "poi_longitude": "-97.4989223",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-219-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0987-71ba-9d95-1cbd9ac21ffb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0987-71ba-9d95-1cbd9ac21ffb",
        "storage_key": "property/6767906449165601/019cfb3f-0987-71ba-9d95-1cbd9ac21ffb.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4geZefiuocRE5uwjkO8LtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_423fab31-6d0d-408f-a1d5-4021a898f4fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Wichita Dwight D. Eisenhower National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2277 Eisenhower Airport Pkwy, Wichita, KS 67209, USA",
      "poi_short_description": "Regional airport offering a host of domestic flights to & from the largest city in Kansas.",
      "poi_long_description": "Visitors say this airport is clean, easy to navigate, and has friendly staff. They also highlight its convenient rental car pickup and drop-off, quick security lines, and efficient check-in process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-432a-7665-ae0c-346398bb08ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-432a-7665-ae0c-346398bb08ae",
        "storage_key": "property/6767906449165601/019cfb3f-432a-7665-ae0c-346398bb08ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.flywichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8128607608438818969&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wichita-dwight-d-eisenhower-national-airport",
      "poi_latitude": "37.6493348",
      "poi_longitude": "-97.4273195",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-946-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-095f-73fa-8ea7-0b92f8500932.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-095f-73fa-8ea7-0b92f8500932",
        "storage_key": "property/6767906449165601/019cfb3f-095f-73fa-8ea7-0b92f8500932.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0QnDVHnuocRmYiIe42dznA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_19407e95-8fcd-4b22-9b37-1c050ee0db5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Textron Aviation C5",
      "poi_type": "Transportation & Transit",
      "poi_address": "C5, Wichita, KS 67209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10430272576288837024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-c5",
      "poi_latitude": "37.6400806",
      "poi_longitude": "-97.4226631",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-095f-73fa-8ea7-0b92f8500932.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-095f-73fa-8ea7-0b92f8500932",
        "storage_key": "property/6767906449165601/019cfb3f-095f-73fa-8ea7-0b92f8500932.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ZkKB0jnuocRoM0xbKXFv5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0ad5846d-d221-428e-a1f3-3a4540d83081",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Westport Airport-71K",
      "poi_type": "Transportation & Transit",
      "poi_address": "2558 S Kessler St, Wichita, KS 67217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-43ba-7528-88f9-c68be9e56028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-43ba-7528-88f9-c68be9e56028",
        "storage_key": "property/6767906449165601/019cfb3f-43ba-7528-88f9-c68be9e56028.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4024429820277561674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westport-airport-71k",
      "poi_latitude": "37.6482314",
      "poi_longitude": "-97.384478",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 316-943-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-095f-73fa-8ea7-0b92f8500932.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-095f-73fa-8ea7-0b92f8500932",
        "storage_key": "property/6767906449165601/019cfb3f-095f-73fa-8ea7-0b92f8500932.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4S_s8TmuocRShkiZZml2Tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0c7a3c07-16b0-444e-a891-7e4091fbc856",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "City of Wichita ​City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "455 N Main, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-4420-763d-9c90-cfe3cd348250.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-4420-763d-9c90-cfe3cd348250",
        "storage_key": "property/6767906449165601/019cfb3f-4420-763d-9c90-cfe3cd348250.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wichita.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4707618743980993027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-wichita-city-hall",
      "poi_latitude": "37.6929601",
      "poi_longitude": "-97.339002",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-942-4482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0cf3-77a2-83f3-e6e38b2f0dec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0cf3-77a2-83f3-e6e38b2f0dec",
        "storage_key": "property/6767906449165601/019cfb3f-0cf3-77a2-83f3-e6e38b2f0dec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVI-vcTjuocRAyr1PE7SVEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_d26e8e20-12ef-43d5-9dcf-51fbbd20de2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Cargill Protein Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "825 E Douglas Ave, Wichita, KS 67202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-441a-73e4-a224-dc2d7a31449b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-441a-73e4-a224-dc2d7a31449b",
        "storage_key": "property/6767906449165601/019cfb3f-441a-73e4-a224-dc2d7a31449b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cargill.com/page/cargill-protein-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=1167281867094812957&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cargill-protein-headquarters",
      "poi_latitude": "37.6853999",
      "poi_longitude": "-97.3279603",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 316-291-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVWVDpXjuocRHenwcKwEMxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f6407d2d-fa53-4be4-9c3e-110ccf62c1c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "BG Products, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "740 S Wichita St, Wichita, KS 67213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-44b7-712e-b93c-722651a0fedc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3f-44b7-712e-b93c-722651a0fedc",
        "storage_key": "property/6767906449165601/019cfb3f-44b7-712e-b93c-722651a0fedc.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://www.bgprod.com/?utm_source=google&utm_medium=company-profile&utm_content=website-button",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729482907961109433&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bg-products-inc",
      "poi_latitude": "37.67794190000001",
      "poi_longitude": "-97.3403841",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-961-6228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxN7feXjuocRuavp9PHIwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_80dbc0c4-f2b3-437e-8e51-125545875be4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Textron Aviation C6",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2655 S Hoover Rd W22, Wichita, KS 67215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.txtav.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3817218495772905269&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "textron-aviation-c6",
      "poi_latitude": "37.6483078",
      "poi_longitude": "-97.4184875",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-517-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxff2E9jnuocRNU-YVv97-TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_efdedb00-3ba9-4c33-9ed4-7d0a187c9370",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Wildcat Power Gen",
      "poi_type": "Major Employers & Offices",
      "poi_address": "930 N Mosley St, Wichita, KS 67214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://wildcatpowergen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11235588861826930689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildcat-power-gen",
      "poi_latitude": "37.700105",
      "poi_longitude": "-97.3273464",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 620-500-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwOMbpG3pIcRAZiHh4rU7Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_339cb680-6ba0-4065-9de8-5ae2aa015fdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Kensler Elementary School",
      "poi_type": "Education",
      "poi_address": "1030 N Wilbur Ln, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-36b4-73e8-841b-2bf28c946d39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-36b4-73e8-841b-2bf28c946d39",
        "storage_key": "property/6767906449165601/019d7912-36b4-73e8-841b-2bf28c946d39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kensler.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6309509399426161228&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kensler-elementary-school",
      "poi_latitude": "37.7023233",
      "poi_longitude": "-97.4314923",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 316-973-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt0OcWYfguocRTNrIm17hj1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5430f00c-f424-4f08-ba80-347974bf36d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Wilbur Middle School",
      "poi_type": "Education",
      "poi_address": "340 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-2d2a-7719-aa8e-a52d18bbd7f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2d2a-7719-aa8e-a52d18bbd7f0",
        "storage_key": "property/6767906449165601/019d7912-2d2a-7719-aa8e-a52d18bbd7f0.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://wilbur.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15968973275339850066&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wilbur-middle-school",
      "poi_latitude": "37.688307",
      "poi_longitude": "-97.442531",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-973-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSQPgYybeuocRUoFWMJYwnd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fe8959a1-d2b5-45f2-bbbf-1bda594a64ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Wichita Northwest High School",
      "poi_type": "Education",
      "poi_address": "1220 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-3006-75b8-86fd-49b3a456ce20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3006-75b8-86fd-49b3a456ce20",
        "storage_key": "property/6767906449165601/019d7912-3006-75b8-86fd-49b3a456ce20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://northwest.usd259.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11315080650523255213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-northwest-high-school",
      "poi_latitude": "37.70475589999999",
      "poi_longitude": "-97.440365",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-973-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKdEivNXfuocRraFV2-Y9B50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_4a5ec119-2741-470e-9ddf-6ac744eb9af0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Bishop Carroll Catholic High School",
      "poi_type": "Education",
      "poi_address": "8101 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-307b-7658-9bc6-1dd25d6e75d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-307b-7658-9bc6-1dd25d6e75d1",
        "storage_key": "property/6767906449165601/019d7912-307b-7658-9bc6-1dd25d6e75d1.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://bcchs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6469757000547285599&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bishop-carroll-catholic-high-school",
      "poi_latitude": "37.6933278",
      "poi_longitude": "-97.4365556",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-722-2390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUgtmoLguocRX7q3uLYxyVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_18e74474-aaab-4dd4-a05f-0096ebcf5116",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "St. Francis of Assisi Catholic School",
      "poi_type": "Education",
      "poi_address": "853 N Socora St, Wichita, KS 67212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.stfranciswichita.com/index.php/school",
      "poi_directions_map_url": "https://maps.google.com/?cid=11799891258123803907&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "st-francis-of-assisi-catholic-school",
      "poi_latitude": "37.6971551",
      "poi_longitude": "-97.4388012",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-722-5171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrQ2sPSreuocRA920rJSiwaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6b856559-4ded-491e-b770-fe7ff9cacfd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "WSU Tech - City Center",
      "poi_type": "Education",
      "poi_address": "301 S Grove St, Wichita, KS 67211, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-3853-770c-aa1f-552a6e9af3f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3853-770c-aa1f-552a6e9af3f5",
        "storage_key": "property/6767906449165601/019d7912-3853-770c-aa1f-552a6e9af3f5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wsutech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13397923867905285235&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wsu-tech-city-center",
      "poi_latitude": "37.6822022",
      "poi_longitude": "-97.3093214",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 316-677-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ1WB7p3juocRc9w4ysX87rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_89d15dba-ad07-4235-8c06-cac9f03fd834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Wichita State University",
      "poi_type": "Education",
      "poi_address": "1845 Fairmount St, Wichita, KS 67260, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-48a7-764c-81ff-747d444ce700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-48a7-764c-81ff-747d444ce700",
        "storage_key": "property/6767906449165601/019d7912-48a7-764c-81ff-747d444ce700.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wichita.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193094869087118587&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wichita-state-university",
      "poi_latitude": "37.7190782",
      "poi_longitude": "-97.291526",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 316-978-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f37ff9e35e81",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f37ff9e35e81.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYDXm-niuocR-2Sr9ilwbx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9f402cd3-fd68-46b8-800a-dabac7fb8435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Bella Vita Bistro",
      "poi_type": "Restaurants",
      "poi_address": "9506 W Central Ave, Wichita, KS 67212, USA",
      "poi_short_description": "Traditional & inventive Italian dishes in a charming villalike atmosphere with a full bar.",
      "poi_long_description": "People say this Italian restaurant serves delicious dishes, including gluten-free options, and offers a variety of pasta, seafood, and meat entrees. They highlight the reasonable prices, cozy and romantic atmosphere, and attentive service. They also like the fresh bread and oil served at the beginning of the meal.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-4738-772b-a4b0-d78fd8c401c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4738-772b-a4b0-d78fd8c401c6",
        "storage_key": "property/6767906449165601/019d7912-4738-772b-a4b0-d78fd8c401c6.webp",
        "width": 1000,
        "height": 662
      },
      "poi_business_url": "https://www.facebook.com/share/1AMZ6MbMsH/?mibextid=wwXIfr",
      "poi_directions_map_url": "https://maps.google.com/?cid=15651444174799193471&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bella-vita-bistro",
      "poi_latitude": "37.694472",
      "poi_longitude": "-97.452728",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-941-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWISxhjhuocRf0XDVI0ZNdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_f0b44b63-6cb3-4d27-ba20-6bf7374826c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Egg Crate Cafe and Catering",
      "poi_type": "Restaurants",
      "poi_address": "8606 W 13th St N Ste 150, Wichita, KS 67212, USA",
      "poi_short_description": "Classic American breakfast & a varied lunch menu are the draw at this artsy, cozy & relaxed cafe.",
      "poi_long_description": "People say this restaurant serves delicious waffles, chicken fried steak, and tacos. They also highlight the friendly staff, cozy atmosphere, and generous portions.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-4b8f-7468-9d32-f1b99da760ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4b8f-7468-9d32-f1b99da760ba",
        "storage_key": "property/6767906449165601/019d7912-4b8f-7468-9d32-f1b99da760ba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.eggcratecafewichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=631009427212421683&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "egg-crate-cafe-and-catering",
      "poi_latitude": "37.7100068",
      "poi_longitude": "-97.4422643",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-295-2822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlyZDEdffuocRM0rrFrvLwQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6402d973-3691-47d0-b2b6-b38d2cc620c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Kobe Steak House of Japan",
      "poi_type": "Restaurants",
      "poi_address": "8760 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Stylish local Japanese steakhouse chain serving surf 'n' turf grilled tableside & cocktails.",
      "poi_long_description": "People say this Japanese restaurant offers delicious steak, fried rice, and chicken, and the chefs provide entertaining hibachi performances. They highlight the fun and welcoming atmosphere, and the attentive service. They also like the generous portions and the option to take food home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-6388-7135-b72c-61e33a721a93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6388-7135-b72c-61e33a721a93",
        "storage_key": "property/6767906449165601/019d7912-6388-7135-b72c-61e33a721a93.webp",
        "width": 1280,
        "height": 893
      },
      "poi_business_url": "https://www.kobewichita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12227000956179860781&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kobe-steak-house-of-japan",
      "poi_latitude": "37.7236958",
      "poi_longitude": "-97.4440675",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-558-3331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc_k37JTfuocRLU12lZYIr6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_4981f30f-227a-4393-a6cb-e740608af03e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Los Cocos Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1335 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Casual Mexican restaurant with cocktails, margaritas, and happy hour specials, plus a kids' menu.",
      "poi_long_description": "People say this Mexican restaurant serves tasty, Americanized Mexican food with generous portions. They also highlight the reasonable prices and friendly, attentive service.\n\nOther reviews mention the food can be average.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-5389-726f-b7e0-9311552b4730.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5389-726f-b7e0-9311552b4730",
        "storage_key": "property/6767906449165601/019d7912-5389-726f-b7e0-9311552b4730.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://loscocosrestaurant.com/loscocos3?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12483495291740931084&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "los-cocos-mexican-restaurant",
      "poi_latitude": "37.707708",
      "poi_longitude": "-97.4448976",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-722-6267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFccLQNHfuocRDMR609NIPq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_15834d59-359f-423c-878a-fb531c9dface",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Ninza Sushi Bar (West)",
      "poi_type": "Restaurants",
      "poi_address": "8428 W 13th St N #100, Wichita, KS 67212, USA",
      "poi_short_description": "Classic & creative sushi served along with sashimi, soups & salads in casual yet modern environs.",
      "poi_long_description": "People say this Japanese restaurant serves delicious sushi, miso soup, and fried rolls. They highlight the food is fresh and well-made, and the drinks are incredible. They also like the professional staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-5833-70fa-9724-288587a048a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5833-70fa-9724-288587a048a5",
        "storage_key": "property/6767906449165601/019d7912-5833-70fa-9724-288587a048a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ninzasushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13815862643176907051&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ninza-sushi-bar-west",
      "poi_latitude": "37.7080822",
      "poi_longitude": "-97.4418533",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-558-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc1Gwp9ffuocRKyEm2N_Nu78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_eb39686b-bb44-48e4-8bb8-5dcfd583c283",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Bionic Burger",
      "poi_type": "Restaurants",
      "poi_address": "660 N Ridge Rd #101, Wichita, KS 67212, USA",
      "poi_short_description": "Low-key fast-food joint offering a variety of burgers, plus fries, onion rings & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers and pork loin sandwiches. They also highlight the friendly staff and fast service.\n\nSome reviews mention the fries can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-642f-7474-a30b-ea79845ab272.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-642f-7474-a30b-ea79845ab272",
        "storage_key": "property/6767906449165601/019d7912-642f-7474-a30b-ea79845ab272.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bionic-burger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8152269197991125485&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bionic-burger",
      "poi_latitude": "37.6929667",
      "poi_longitude": "-97.4257361",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 316-945-3838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6z1IvI_guocR7aGem6StInE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_71db5c16-6e65-4f24-a14a-1d72a6b45adb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Pizza Ranch",
      "poi_type": "Restaurants",
      "poi_address": "2121 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Buffet chain offering pizza, fried chicken & classic American sides in an Old West-themed setting.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of pizzas, fried chicken, and a fresh salad bar. They also highlight the friendly staff, clean surroundings, and good value, especially for families.\n\nOther reviews mention the pizza can be average.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-6c6b-752e-96f3-0f8b9f464dc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6c6b-752e-96f3-0f8b9f464dc6",
        "storage_key": "property/6767906449165601/019d7912-6c6b-752e-96f3-0f8b9f464dc6.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://pizzaranch.com/locations/ks/wichita/2121-n-tyler-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=13258145881540485260&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pizza-ranch",
      "poi_latitude": "37.7224591",
      "poi_longitude": "-97.4465582",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-867-2007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55Z4om7fuocRjGCHQW9l_rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_bec10d55-5d30-4027-aa07-17e7809e8ed9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Spangles",
      "poi_type": "Restaurants",
      "poi_address": "612 N Tyler Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Regional fast-food chain offering burgers, sandwiches, fries, ice cream & breakfast items.",
      "poi_long_description": "Diners say this fast food restaurant serves delicious burgers and fries, especially the garlic parm burger and fries with garlic parm seasoning. They also highlight the friendly staff and clean dining area.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-70aa-76b9-b8e0-d3a8e23841fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-70aa-76b9-b8e0-d3a8e23841fa",
        "storage_key": "property/6767906449165601/019d7912-70aa-76b9-b8e0-d3a8e23841fa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.spanglesinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13623777411834297823&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spangles",
      "poi_latitude": "37.6931865",
      "poi_longitude": "-97.4440261",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-721-1769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0986-7232-8f62-e8c75806b7f0",
        "storage_key": "property/6767906449165601/019cfb3f-0986-7232-8f62-e8c75806b7f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7e_3KS_euocR371fy19hEb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b35739eb-b339-444e-a6df-a322e919b548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Dillons",
      "poi_type": "Shopping & Retail",
      "poi_address": "8828 W 13th St N, Wichita, KS 67212, USA",
      "poi_short_description": "Supermarket chain with mainstream grocery items, plus natural & organic foods.",
      "poi_long_description": "People say this grocery store offers a good selection of fresh food, great deals, and decent prices. They also highlight the friendly and helpful staff, and convenient locations.\n\nSome reviews mention the stores can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-7240-77f8-a216-c6734741bc82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7240-77f8-a216-c6734741bc82",
        "storage_key": "property/6767906449165601/019d7912-7240-77f8-a216-c6734741bc82.webp",
        "width": 948,
        "height": 1280
      },
      "poi_business_url": "https://www.dillons.com/stores/grocery/ks/wichita/13th-tyler-dillons/615/00016?cid=loc_61500016_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12522967667938777193&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dillons",
      "poi_latitude": "37.7099673",
      "poi_longitude": "-97.4457532",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 316-722-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-097f-724f-ae20-5be4ae3dc458.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-097f-724f-ae20-5be4ae3dc458",
        "storage_key": "property/6767906449165601/019cfb3f-097f-724f-ae20-5be4ae3dc458.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr1Zh5dDfuocRaVgxlb6Eyq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0fe79cb5-4f74-44d4-9276-7f93fac37527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "765 N Maize Rd, Wichita, KS 67212, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide variety of reasonably priced produce, delicious prepared foods, and unique items. They highlight the fresh produce, exceptional selection, and affordable prices. They also like the friendly and helpful staff, and the clean, well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-777a-71b5-802c-368022e84acd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-777a-71b5-802c-368022e84acd",
        "storage_key": "property/6767906449165601/019d7912-777a-71b5-802c-368022e84acd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/wichita/765-n-maize-rd/f301",
      "poi_directions_map_url": "https://maps.google.com/?cid=2076619409595280387&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "37.696619",
      "poi_longitude": "-97.463619",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-097f-724f-ae20-5be4ae3dc458.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-097f-724f-ae20-5be4ae3dc458",
        "storage_key": "property/6767906449165601/019cfb3f-097f-724f-ae20-5be4ae3dc458.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aHHu0veuocRA6ybwlmi0Rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_434a6b92-7320-4d0e-bd1a-95ead8663417",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Kansas Grown! Farmers' Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7001 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Lively spot for baked goods, meats, fruits, vegetables and other homemade goodies.",
      "poi_long_description": "People say this farmers market offers a wide variety of fresh produce, meats, baked goods, and homemade products. They highlight the fun and lively atmosphere, and the opportunity to support local vendors. They also like the personalized cutting boards and fresh bagels with cream cheese.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-7f46-74db-a11b-bb9a873018df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7f46-74db-a11b-bb9a873018df",
        "storage_key": "property/6767906449165601/019d7912-7f46-74db-a11b-bb9a873018df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kansas-grown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4007296560154556562&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kansas-grown-farmers-market",
      "poi_latitude": "37.7224008",
      "poi_longitude": "-97.4250089",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 316-749-0223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR4POI23guocRkjioaf3GnDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_33c87f6a-308f-4ede-9a61-20f854e0e839",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Garden Center at The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8444 W McCormick Ave, Wichita, KS 67209, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-823d-727c-aa5b-6ddc7fce33a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-823d-727c-aa5b-6ddc7fce33a4",
        "storage_key": "property/6767906449165601/019d7912-823d-727c-aa5b-6ddc7fce33a4.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "https://www.homedepot.com/l/W-Wichita/KS/Wichita/67209/2205/garden-center?emt=GCGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8841910440537831903&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garden-center-at-the-home-depot",
      "poi_latitude": "37.6738803",
      "poi_longitude": "-97.4398663",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-773-1988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5Sitxh3euocR3zkTALPGtHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden_center"
    },
    {
      "id": "custom_618fffb0-218b-4ca2-b50b-4ef27ff53acd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide variety of clothes. They also highlight the friendly and helpful staff, and the great deals with rewards and coupons.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-82c3-72ef-a20f-eaebf4c13078.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-82c3-72ef-a20f-eaebf4c13078",
        "storage_key": "property/6767906449165601/019d7912-82c3-72ef-a20f-eaebf4c13078.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ks/wichita-248.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16822897022719900525&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "37.6753588",
      "poi_longitude": "-97.4231881",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-942-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaS-Q7LvguocRbTsy7LXvduk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_46d90e52-8acc-47d0-a8e6-077ba602b132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "6700-6820 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-9086-771b-a829-a217eec92fac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9086-771b-a829-a217eec92fac",
        "storage_key": "property/6767906449165601/019d7912-9086-771b-a829-a217eec92fac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=5215421891585969296&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-j-maxx",
      "poi_latitude": "37.6751323",
      "poi_longitude": "-97.4212545",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-943-2055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF83OarnguocRkAzH8ZPmYEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9dd84e19-6561-49c2-96ab-01798d29f375",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Office Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "613 S Dugan Rd Suite 100, Wichita, KS 67209, USA",
      "poi_short_description": "Chain selling office & school supplies, electronics & furniture (most featuring a copy center).",
      "poi_long_description": "Chain selling office & school supplies, electronics & furniture (most featuring a copy center).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-97a8-733d-876b-f3f6f2686b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-97a8-733d-876b-f3f6f2686b1d",
        "storage_key": "property/6767906449165601/019d7912-97a8-733d-876b-f3f6f2686b1d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.officedepot.com/storelocator/ks/wichita/office-depot-2157?utm_source=google&utm_medium=organic&utm_campaign=gmb_2157_website_retail",
      "poi_directions_map_url": "https://maps.google.com/?cid=12348941520419136947&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "office-depot",
      "poi_latitude": "37.6751751",
      "poi_longitude": "-97.4174346",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-943-0054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJweROgbjguocRs6WnpOJAYKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_9b81d1ca-70d7-4bd5-a993-5eae431860a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Towne West Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "4600 W Kellogg Dr, Wichita, KS 67209, USA",
      "poi_short_description": "Traditional indoor shopping mall featuring a range of stores, several casual eateries & a cinema.",
      "poi_long_description": "People say this shopping center offers a movie theater and a Dillard's Clearance Store with big discounts on brand names.\n\nOther reviews mention the mall can be abandoned and many stores can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-9a47-7519-946b-6e079278048a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9a47-7519-946b-6e079278048a",
        "storage_key": "property/6767906449165601/019d7912-9a47-7519-946b-6e079278048a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://townewestsquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=668552573609541603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "towne-west-square",
      "poi_latitude": "37.6778456",
      "poi_longitude": "-97.3999493",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 316-945-1236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOS9HONnguocR43-rBwYtRwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_61bb4cb0-8b41-400b-860a-2e5bd0dde273",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2441 N Maize Rd STE 2401, Wichita, KS 67205, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide selection of TVs, phones, computers, cameras, smartwatches, appliances, and audio equipment. They also highlight the helpful and knowledgeable staff, and the quick and efficient service.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-9ab4-70fc-86c4-631c8e44be11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9ab4-70fc-86c4-631c8e44be11",
        "storage_key": "property/6767906449165601/019d7912-9ab4-70fc-86c4-631c8e44be11.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.bestbuy.com/ks/wichita/2441-n-maize-rd-1513.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=17016422986324912777&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "37.730423",
      "poi_longitude": "-97.464477",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 316-524-2079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0964-74ad-b9ce-f77a200279c8",
        "storage_key": "property/6767906449165601/019cfb3f-0964-74ad-b9ce-f77a200279c8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP7Iw4pPfuocRiSqwl4x6Juw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_d37d0d57-3ac3-4aaf-abab-08728dde0d49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Regal Warren West",
      "poi_type": "Entertainment",
      "poi_address": "9150 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "People say this movie theater offers a variety of films, including IMAX and Screen X options. They also highlight the comfortable seats, clean facilities, and friendly staff.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-9ff4-76fd-a3a7-a63b37295ba7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9ff4-76fd-a3a7-a63b37295ba7",
        "storage_key": "property/6767906449165601/019d7912-9ff4-76fd-a3a7-a63b37295ba7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-warren-west-1443?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3042760775773274275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-warren-west",
      "poi_latitude": "37.724285",
      "poi_longitude": "-97.44779",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-b328-767f-96ff-725bc08653ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-b328-767f-96ff-725bc08653ac",
        "storage_key": "property/6767906449165601/019d7912-b328-767f-96ff-725bc08653ac.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXKGy-ffuocRo0B16M0OOio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b01b38e0-6a6b-4b71-87dd-bf52bbb299ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "All Star Sports",
      "poi_type": "Entertainment",
      "poi_address": "8333 W 21st St, Wichita, KS 67205, USA",
      "poi_short_description": "All-ages amusement park offering mini-golf, go-karts, bumper boats, arcade games & a climbing wall.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including go-karts, laser tag, and mini golf. They also highlight the friendly and helpful staff, and the affordable prices, especially with deals.\n\nOther reviews mention the games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019d7912-a8f1-71b9-886e-b34e7a106b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-a8f1-71b9-886e-b34e7a106b2b",
        "storage_key": "property/6767906449165601/019d7912-a8f1-71b9-886e-b34e7a106b2b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.allstarwichita.com/sports/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1428230526315511839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "all-star-sports",
      "poi_latitude": "37.7219229",
      "poi_longitude": "-97.4382853",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 316-722-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0977-7668-a791-eef3c3c785df",
        "storage_key": "property/6767906449165601/019cfb3f-0977-7668-a791-eef3c3c785df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRcLIBeDfuocRH8BnuhgY0hM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_59812736-2481-4a9c-9265-77fe28e398d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "Sojourner’s Coffee House",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "sojourner-s-coffee-house",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ef4ff08a-4a2d-47bd-900e-162a06c95292",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "poi_name": "JOANN Fabric and Crafts",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "joann-fabric-and-crafts",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c4c1434074f5bf45d8bf6a27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_69709b3e2233475550d021c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e5532b3243e8f0d1a8ac2499",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_56cfcebd93b9d951610af686",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bd41586e4063a3d0dbb48a0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_7a59b7102cfcc7ccefe985b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_14db9816-6f06-4572-8e0c-d9f8339e2178",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "rating": "5.0",
      "name": "William Scott",
      "text": "The maintenance guys are great. Every issue that I've had, they've been very good at their resolve.  There hasn't been very many issues requiring repairs. Mostly it's been preventive that could have caused problems or injuries. Thanks to the maintenance team for their time and efforts to provide safe space for us tenants",
      "date": "2025-10-06",
      "title": ""
    },
    {
      "id": "custom_eddf4399-05ef-42c7-8fec-75cbfd8136b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "rating": "5.0",
      "name": "Sydney Eash",
      "text": "Hunter is the absolute most beautiful human to have as your manager. They are attentive here, they listen and do anything and everything to make you feel at HOME. There are monthly activities for the tenants, so many great amenities, and just all around good energy. We are so thankful to have this place as a home, and again, HUNTER. A gorgeous human!",
      "date": "2025-07-12",
      "title": ""
    },
    {
      "id": "custom_76031e79-a031-4d72-b12c-91ab359285ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "rating": "5.0",
      "name": "Jon Hull",
      "text": "Personally I’ve rarely had issues, and I’ve never had one that hasn’t been responded to immediately. Crown Chase is a great community. Neighbours are friendly but also respectful. Great quiet place to call home. I’ve been here for 2 years and was happy to extend. The management staff are always happy to help with any questions, as well as being friendly/personable while maintaining a professional attitude when interacting with residents and applicants alike. Would recommend crown chase to anyone looking for a place to call home.",
      "date": "2025-09-14",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b989cc9c-a2fd-4803-b60e-223370d62cb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-9f0a-777a-844d-d4552d17d7a9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of an apartment complex with a pool and buildings",
        "public_id": "019cfb3f-9f0a-777a-844d-d4552d17d7a9",
        "storage_key": "property/6767906449165601/019cfb3f-9f0a-777a-844d-d4552d17d7a9.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Crown Chase Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f45715e601bdb1ec0530ac8"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03b3-af07-703b-a4a6-6afcee4638cc",
      "lead_source": "LANDING_PAGE",
      "name": "case-crown-chase-apts-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601"
    },
    {
      "lead_collector_id": "019cf79d-3980-7572-8ef9-d6c81b73f833",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "crown-chase-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "generator",
      "page_item_url": "apartments-pool-wichita-ks-crown-chase",
      "search_query": "apartments with pool in Wichita KS",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Wichita, KS",
      "h2_subtitle": "Discover your perfect home at Crown Chase Apartments. Enjoy a vibrant community with enticing amenities, including a refreshing pool in Wichita, KS.",
      "page_copy": "Welcome to Crown Chase Apartments, where residents enjoy an exceptional lifestyle enriched by a range of amenities, including a cooling oasis right outside your door—a captivating pool. Nestled in West Wichita, Crown Chase offers convenient access to local attractions while providing a peaceful retreat.\n\nOur community boasts spacious one and two-bedroom apartments designed with your comfort in mind. Residents are invited to unwind by the sparkling pool, stay active in the fully equipped fitness center, or let their furry friends play at the pet-friendly dog park. Experience life at its finest in our welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
      "featured_image_media": {
        "alt_text": "Exterior of apartment building entrance with mailboxes and landscaping.",
        "public_id": "019cfb3e-d42d-7462-888c-ebc44d8af97f",
        "storage_key": "property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Wichita, KS",
      "seo_description": "Discover Crown Chase Apartments in Wichita, KS, offering amazing amenities including a refreshing pool. Your ideal lifestyle starts here!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "generator",
      "page_item_url": "crown-chase-dog-park-apartments",
      "search_query": "Crown Chase dog park apartments",
      "category": "Amenity",
      "h1_title": "Crown Chase Dog Park Apartments",
      "h2_subtitle": "Welcome to Crown Chase Apartments, a pet-friendly haven. Enjoy our dedicated dog park, perfect for you and your furry friends.",
      "page_copy": "Crown Chase Apartments in Wichita, KS is more than just a place to live; it’s a haven for both you and your pets. Featuring a thoughtfully designed dog park, our community ensures that your four-legged companions have ample space to play and socialize.\n\nLiving at Crown Chase means enjoying a comfortable lifestyle with spacious one and two-bedroom layouts and access to amenities like a refreshing pool, fitness center, and convenient gated access. Located in the vibrant West Wichita neighborhood, our community is the perfect place for pet lovers seeking a welcoming environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
      "featured_image_media": {
        "alt_text": "Exterior of apartment building entrance with mailboxes and landscaping.",
        "public_id": "019cfb3e-d42d-7462-888c-ebc44d8af97f",
        "storage_key": "property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Crown Chase Dog Park Apartments",
      "seo_description": "Explore Crown Chase Apartments with a great dog park and pet-friendly amenities. Perfect for pet owners in Wichita, KS!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-west-wichita-crown-chase",
      "search_query": "fitness center apartments in West Wichita",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in West Wichita",
      "h2_subtitle": "Crown Chase Apartments offers a convenient fitness center. Stay active and thrive in our vibrant community in West Wichita.",
      "page_copy": "At Crown Chase Apartments in West Wichita, maintaining a healthy lifestyle is within easy reach with our fully-equipped fitness center. Our community provides modern amenities designed to enhance your everyday living experience, making it a prime choice for those seeking fitness-focused apartments.\n\nChoose from our spacious one or two-bedroom floor plans and enjoy a variety of amenities including a refreshing pool and a pet-friendly dog park. Located in the lively area of West Wichita, Crown Chase Apartments is a perfect blend of comfort and convenience, providing everything you need to live and thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
      "featured_image_media": {
        "alt_text": "Exterior of apartment building entrance with mailboxes and landscaping.",
        "public_id": "019cfb3e-d42d-7462-888c-ebc44d8af97f",
        "storage_key": "property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in West Wichita",
      "seo_description": "Discover Crown Chase Apartments in West Wichita with a modern fitness center, perfect for active residents. Your vibrant lifestyle awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-wichita-crown-chase",
      "search_query": "apartments with in-unit laundry Wichita",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Wichita",
      "h2_subtitle": "Experience convenience at Crown Chase Apartments. Enjoy in-unit laundry in our spacious Wichita homes, designed for modern living.",
      "page_copy": "Crown Chase Apartments in Wichita, KS offers the ultimate convenience with in-unit laundry facilities, making everyday life easier and more comfortable. Our community combines practical amenities with modern design, perfect for anyone seeking a seamless living experience.\n\nExplore our spacious one and two-bedroom floor plans, which come equipped with essential features like air conditioning and in-unit washers and dryers. Our residents also benefit from amenities such as a refreshing pool, a fitness center, and a dog park. Situated in the vibrant West Wichita area, Crown Chase is your gateway to a comfortable lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
      "featured_image_media": {
        "alt_text": "Exterior of apartment building entrance with mailboxes and landscaping.",
        "public_id": "019cfb3e-d42d-7462-888c-ebc44d8af97f",
        "storage_key": "property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Wichita",
      "seo_description": "Find your ideal home at Crown Chase Apartments in Wichita, offering in-unit laundry and exceptional amenities. Enjoy convenience and comfort!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-67212-crown-chase",
      "search_query": "air conditioned apartments 67212",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments 67212",
      "h2_subtitle": "Crown Chase Apartments in the 67212 area offers air-conditioned comfort. Enjoy a cool retreat in West Wichita.",
      "page_copy": "Experience ultimate comfort at Crown Chase Apartments in the heart of Wichita, KS. Our air-conditioned apartments in the 67212 area ensure you stay cool and relaxed year-round. Enjoy the comforts of a modern lifestyle in our one and two-bedroom layouts, complete with top-notch amenities.\n\nApart from air conditioning, our residents enjoy a range of features, including a community pool, fitness center, and a pet-friendly dog park. Located in the vibrant West Wichita neighborhood, Crown Chase Apartments provides a perfect blend of tranquility and excitement in a convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
      "featured_image_media": {
        "alt_text": "Exterior of apartment building entrance with mailboxes and landscaping.",
        "public_id": "019cfb3e-d42d-7462-888c-ebc44d8af97f",
        "storage_key": "property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments 67212",
      "seo_description": "Discover air-conditioned living at Crown Chase Apartments in the 67212 area. Enjoy modern amenities and cool comfort in West Wichita.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-west-wichita-crown-chase",
      "search_query": "one bedroom apartments west wichita",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments West Wichita",
      "h2_subtitle": "Discover Crown Chase Apartments in West Wichita. Our one-bedroom homes offer comfort and style in a convenient location.",
      "page_copy": "Welcome to Crown Chase Apartments, where you can find beautiful one bedroom apartments in West Wichita. Our thoughtfully designed floor plans offer spacious living with modern amenities, perfect for individuals or couples looking for comfort and convenience.\n\nNestled in a vibrant community, our one-bedroom apartments come with features like air conditioning, in-unit washer/dryer, and access to a fitness center and a relaxing pool. Ideally located in West Wichita, Crown Chase Apartments provide the perfect blend of calm living with the bustle of city convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
      "featured_image_media": {
        "alt_text": "Exterior of apartment building entrance with mailboxes and landscaping.",
        "public_id": "019cfb3e-d42d-7462-888c-ebc44d8af97f",
        "storage_key": "property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments West Wichita",
      "seo_description": "Explore one bedroom apartments at Crown Chase in West Wichita. Enjoy modern amenities in a vibrant community. Find your perfect home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165601",
      "source": "generator",
      "page_item_url": "two-bedroom-apts-wichita-ks-crown-chase",
      "search_query": "two bedroom apts wichita ks",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apts Wichita KS",
      "h2_subtitle": "Explore Crown Chase's spacious two-bedroom apts in Wichita, KS. Enjoy modern amenities in a vibrant community setting.",
      "page_copy": "At Crown Chase Apartments in Wichita, KS, discover spacious two-bedroom apts designed to suit your lifestyle. Our homes offer the perfect combination of ample living space and modern conveniences that cater to your needs.\n\nEach two-bedroom apartment features essentials like air conditioning and in-unit washer and dryer, as well as access to a variety of amenities, including a pool and fitness center. Perfectly positioned in the lively West Wichita area, Crown Chase Apartments ensure you're never far from what the city has to offer, blending comfort with accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
      "featured_image_media": {
        "alt_text": "Exterior of apartment building entrance with mailboxes and landscaping.",
        "public_id": "019cfb3e-d42d-7462-888c-ebc44d8af97f",
        "storage_key": "property/6767906449165601/019cfb3e-d42d-7462-888c-ebc44d8af97f.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apts Wichita KS",
      "seo_description": "Find spacious two-bedroom apartments at Crown Chase in Wichita, KS. Enjoy modern living with great amenities. Discover your next home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5170"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-03TQM332GW"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128851432"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/crown-chase/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KNS5FLJK"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165601/019d1bd7-fd43-76ca-b0ee-ee553299b895.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "50085137982"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "c70c3a4e-e3ec-4b15-8969-800ea5e2f1af"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-772-3675"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "63c834c27949f79caa82cae4"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNPV2psOUFGVDZYU25WcXVmSnM5YXc9PSIsInZhbHVlIjoiZHJPNEV0QXNKcEpmdGhIT3F3M0lyZz09IiwibWFjIjoiZjBjODA5YWU4NGQwZWZjNTRiNjhlZTEwMWUzZTZkNTlmYzcwZGE0N2UyMzdlNWQwMDhjZjAxNjU0NWM1NjBmZSJ9"
    }
  ],
  "custom_qb_id": "5170",
  "custom_ga4_id": "G-03TQM332GW",
  "custom_repli_id": "18128851432",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/crown-chase/register/",
  "custom_google_gtm_id": "GTM-KNS5FLJK",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165601/019d1bd7-fd43-76ca-b0ee-ee553299b895.pdf",
  "custom_hubspot_company_id": "50085137982",
  "custom_rentgrata_property_id": "c70c3a4e-e3ec-4b15-8969-800ea5e2f1af",
  "custom_ppc_tracking_phone_number": "833-772-3675",
  "custom_residentboost_apartment_id": "63c834c27949f79caa82cae4",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNPV2psOUFGVDZYU25WcXVmSnM5YXc9PSIsInZhbHVlIjoiZHJPNEV0QXNKcEpmdGhIT3F3M0lyZz09IiwibWFjIjoiZjBjODA5YWU4NGQwZWZjNTRiNjhlZTEwMWUzZTZkNTlmYzcwZGE0N2UyMzdlNWQwMDhjZjAxNjU0NWM1NjBmZSJ9"
};

export const generatedAt = '2026-08-27T21:38:24.880Z';
